var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticStyle:{"overflow":"hidden"}},[_c('img',{staticClass:"image-card",attrs:{"src":_vm.source,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }